import React from "react";

export class Room extends React.PureComponent {
    render() {
        const {room} = this.props;
        return (
            <div className="roomheader" id={"r" + room.id}>
                <span title="Edit room">
                    <span className="glyphicon glyphicon-edit openmodal-room pointer gi-08x"
                          aria-hidden="true" onClick={this.props.handleEditClick}>
                    </span>
                </span>
                <span title="Delete room">
                    <span className="glyphicon glyphicon-trash openmodal-yesnoroom pointer gi-08x"
                          aria-hidden="true" onClick={this.props.handleRemoveClick}>
                    </span>
                </span>
                <div className="roominfo"
                     title={room.name + "\nlocation: " + room.location}
                     aria-hidden="true">
                    <div className="roomname">{room.name}</div>
                    <div className="roomnumber hidden"></div>
                    <div className="roomlocation hidden">room.location</div>
                </div>
            </div>
        )
    }
}
